import * as React from 'react';
import Paper from '@mui/material/Paper';
import {
  Chart,
  PieSeries,
  Title,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation } from '@devexpress/dx-react-chart';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});


const CustomPieChart = ({ data, valueField, argumentField, sx = {} }) => (
  <ThemeProvider theme={theme}>
    <Paper style={{ backgroundColor:"inherit" }}>
      <Chart data={data} sx={sx}>
        <PieSeries
          valueField={valueField}
          argumentField={argumentField}
        />
      </Chart>
    </Paper>
  </ThemeProvider>
  
);

export default CustomPieChart;